import { observer } from "mobx-react-lite";
import React from "react";

import { FontIcon, Persona, PersonaSize, Stack } from "@bps/fluent-ui";
import { routes } from "@libs/routing/routes.ts";
import { openNewInvoiceFromCalendar } from "@modules/booking/utils/booking.utils.ts";
import { CalendarEvent } from "@stores/booking/models/CalendarEvent.ts";
import { useStores } from "@stores/hooks/useStores.ts";
import { Contact } from "@stores/practice/models/Contact.ts";

import { getSettledIcon } from "../BookingCalendarEvent.utils.ts";

interface InvoiceAttendeeItemProps {
  attendee?: Contact;
  calendarEvent: CalendarEvent;
}

export const InvoiceAttendeeItem: React.FC<InvoiceAttendeeItemProps> = observer(
  ({ attendee, calendarEvent }) => {
    const root = useStores();
    const { routing } = root;

    if (!attendee) return null;

    const calendarEventAttendee = calendarEvent.attendees.find(
      ({ attendeeId }) => attendeeId === attendee?.id
    );

    const invoiceId = calendarEventAttendee?.invoiceIds?.[0];

    const onClick = () => {
      if (invoiceId) {
        routing.push(
          routes.accounts.invoices.invoice.path({
            id: invoiceId
          })
        );
      } else {
        openNewInvoiceFromCalendar(root, calendarEvent.id, attendee.id);
      }
    };
    return (
      <Stack
        horizontal
        verticalAlign="center"
        styles={{ root: { maxWidth: 160, minWidth: 160 } }}
      >
        <Persona
          text={attendee.name}
          id={attendee.id}
          size={PersonaSize.size24}
          imageInitials={attendee.initials}
          styles={{ root: { padding: 8 } }}
          onClick={onClick}
        />
        {invoiceId && (
          <FontIcon
            iconName={getSettledIcon(calendarEventAttendee?.settlementStatus)}
          />
        )}
      </Stack>
    );
  }
);
